import styled from 'styled-components';

import { COLORS, IMPORTANT_NOW, IMPORTANT_NOW_TONE, type ImportantNowTone, SPACE } from '../../../../theme/tokens';
import { Text } from '../../../../components';
import { TITLE_FONT_PX, TITLE_LINE_PX, titleLines } from '../Spotlight/SpotlightPick.styles';

// --- The words of the ONE Spotlight card -----------------------------------------------------
// The section, its strip and the card's box are Home's Spotlight (../Spotlight, the ows-ftux
// prototype's look), every notice in the shape of Lumio's pick (the user, 2026-10-19). These are the
// copy parts each notice fills the card with, on the pick's sizes (SpotlightPick.styles): the eyebrow
// 14px in capitals, the title 20px on one line; the line is the pick's own (PickLine). The TONE says
// what kind of news it is (the eyebrow's ink here, the glow in the Spotlight); the BUTTON says what to
// do about it and is the primary CTA colour on every card, never the tone colour.

/** The eyebrow, as the pick's "Getting started": 14px in capitals, a little tracking, in the tone's ink; one line (a
 *  longer one ellipsizes), so every card keeps one height. */
export const PremiumEyebrow = styled(Text)<{ $tone: ImportantNowTone }>`
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${(p) => IMPORTANT_NOW_TONE[p.$tone].eyebrow};
`;

/** The upgrade card's title: the feature's name (wrapped or cut first), its price and its tier, on the title's line. */
export const PremiumTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACE[8]};
  min-width: 0;

  & > * {
    flex: none;
  }

  & > :first-child {
    flex: 0 1 auto;
  }
`;

/** The title, as the pick's: the card's one strong line, two lines at most (titleLines), its room the strip's
 *  (Spotlight's TitleSlot), so every card keeps one height. */
export const PremiumTitle = styled(Text)`
  ${titleLines}
  min-width: 0;
  max-width: 100%;
  font-size: ${TITLE_FONT_PX}px;
  font-weight: 500;
  color: ${IMPORTANT_NOW.cardTitle};
`;

/** The tier, a pill one title line tall (so the title's row keeps the title's line). */
export const PremiumTierPill = styled(Text)`
  display: inline-flex;
  align-items: center;
  height: ${TITLE_LINE_PX}px;
  padding: ${SPACE[0]} ${SPACE[12]};
  border-radius: 13px;
  font-size: 13px;
  font-weight: 500;
  background: ${IMPORTANT_NOW.premiumPillBg};
  color: ${IMPORTANT_NOW.premiumPillText};
`;

/** The price inside the upgrade card's title, bold, at the title's size (Figma 53:2160). */
export const PremiumPrice = styled.span`
  font-size: ${TITLE_FONT_PX}px;
  font-weight: 700;
  line-height: ${TITLE_LINE_PX}px;
  color: ${IMPORTANT_NOW.premiumPrice};
`;

/** The one-action card's CTA label, in the CTA pill's ink; cut with an ellipsis when the pill is narrower. */
export const PremiumCtaLabel = styled(Text)`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${COLORS.ctaSolidText};
`;
